export default class UserTransportDetailsResponse {
    constructor() {
        this.coordinates = [];
        this.id = undefined;
        this.transport = {
            translations: [],
        };
        this.user = {
            name: undefined,
            firstName: undefined,
            lastName: undefined,
            email: undefined,
        };
        this.averageSpeed = undefined;
        this.direction = undefined;
        this.durationInMinutes = undefined;
        this.burnedCalories = undefined;
        this.savedCo2Gram = undefined;
        this.successful = undefined;
        this.workRelatedTravel = undefined;
        this.startTravelDate = undefined;
        this.finishTravelDate = undefined;
        this.totalDistanceTraveledKilometer = undefined;
        this.totalEarnedCoins = undefined;
        this.successful = false;
        this.workRelated = false;
        this.device = undefined;
        this.carSharingDriver = false;
        this.passengers = [];

        this.includeDirection = null;
        this.companyLocations = [];
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.transport = from.transport;
            to.coordinates = from.coordinates;
            to.user = from.user;
            to.averageSpeed = from.averageSpeed;
            to.successful = from.successful;
            to.direction = from.direction;
            to.savedCo2Gram = from.savedCo2Gram;
            to.burnedCalories = from.burnedCalories;
            to.durationInMinutes = from.durationInMinutes;
            to.startTravelDate = from.startTravelDate;
            to.finishTravelDate = from.finishTravelDate;
            to.totalDistanceTraveledKilometer = from.totalDistanceTraveledKilometer;
            to.totalEarnedCoins = from.totalEarnedCoins;
            to.successfull = from.successfull;
            to.workRelated = from.workRelated;
            to.userRequestedInclude = from.userRequestedInclude;
            to.device = from.device
            to.includeDirection = from.direction;
            to.carSharingDriver = from.carSharingDriver;
            to.passengers = from.passengers ?? [];
            to.companyLocations = from.companyLocations ?? [];
        } else {
            to = new UserTransportDetailsResponse();
        }
    }

    static copy(to, from, locale) {
        UserTransportDetailsResponse.assign(from, to, locale);
        return to;
    }
}
